var map = {
	"./bug/routes.js": 187,
	"./lesson-scale/routes.js": 188,
	"./min-lesson/routes.js": 189,
	"./textbook/routes.js": 204
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 186;


//////////////////
// WEBPACK FOOTER
// ./src/modules (.*)\/routes\.js$
// module id = 186
// module chunks = 10